/**
 * CSRF token from API `/csrf-token` (sets HttpOnly `_csrf` cookie + returns token for X-CSRF-Token).
 * Cached until logout or explicit invalidate.
 */

let cachedCsrf: string | null = null;

export function invalidateCsrfCache(): void {
  cachedCsrf = null;
}

export function getApiBaseUrl(): string {
  return process.env.REACT_APP_API_URL || '';
}

export async function fetchCsrfToken(): Promise<string> {
  if (cachedCsrf) return cachedCsrf;
  const base = getApiBaseUrl();
  const res = await fetch(`${base}/csrf-token`, {
    credentials: 'include',
  });
  if (!res.ok) {
    throw new Error('Failed to fetch CSRF token');
  }
  const data = (await res.json()) as { csrfToken?: string };
  cachedCsrf = data.csrfToken || '';
  return cachedCsrf;
}

/** Use before cookie-authenticated POST/PUT/PATCH/DELETE when not sending Bearer. */
export async function ensureCsrfToken(): Promise<string> {
  return fetchCsrfToken();
}
